import React, {useRef} from 'react';
import Header from '../Header';
import Footer from './Footer';
import useSearchParams from '../../../useSearchParams';

const TelActivityCountFilter = () => {
  const {query, setQuery} = useSearchParams();
  const refFrom = useRef(null);
  const refTo = useRef(null);

  return (
    <>
      <Header title="コールログ件数" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <div className="text-c-base font-bold">コールログ件数</div>
          <div className="flex items-center">
            <input
              min={0}
              type="number"
              defaultValue={query?.telActivityCount?.from}
              onBlur={(e) => {
                const inputValue = e.target.value;
                if (inputValue === '') {
                  const {from, ...restTelActivityCount} = query.telActivityCount || {};
                  setQuery({
                    ...query,
                    telActivityCount: {...restTelActivityCount},
                  });
                } else if (!isNaN(Number(inputValue))) {
                  setQuery({
                    ...query,
                    telActivityCount: {
                      ...query.telActivityCount,
                      from: Number(inputValue),
                    },
                  });
                }
              }}
              ref={refFrom}
              className="form-input w-24 p-2 text-sm"
            />
            <span className="ml-1">件</span>
            <span className="mx-2">~</span>
            <input
              min={0}
              type="number"
              defaultValue={query?.telActivityCount?.to}
              onBlur={(e) => {
                const inputValue = e.target.value;
                if (inputValue === '') {
                  const {to, ...restTelActivityCount} = query.telActivityCount || {};
                  setQuery({
                    ...query,
                    telActivityCount: {
                      ...restTelActivityCount,
                    },
                  });
                } else if (!isNaN(Number(inputValue))) {
                  setQuery({
                    ...query,
                    telActivityCount: {
                      ...query.telActivityCount,
                      to: Number(inputValue),
                    },
                  });
                }
              }}
              ref={refTo}
              className="form-input w-24 p-2 text-sm"
            />
            <span className="ml-1">件</span>
          </div>
        </div>
      </div>
      <Footer
        onClear={() => {
          setQuery({...query, telActivityCount: {}});
          refFrom.current.value = '';
          refTo.current.value = '';
        }}
      />
    </>
  );
};

export default TelActivityCountFilter;